module.exports = __webpack_public_path__ + "static/media/HRT.8ab9ae54.svg";